// extracted by mini-css-extract-plugin
export default {"container":"BDxanp","list":"vvuuXR","listItem":"zqNHlI","buttons":"o6fJs9","text":"LHGUrl","subtitle":"IbzJmJ","secondQuestion":"DCGUAV"};